import StudentRepository from './studentRepository'

export default {
  student: StudentRepository
}
